import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ApiService } from '../../Shared/Services/api.service';
import { endpoints } from '../../../../environments/endpoints';
import { LaravelDefaultResponse } from '../../../Interfaces/api/shared/response.interface';
import { TypedResourceRequest } from '../../Shared/Interfaces/api-request.interface';
import {
  OnboardingListResponse,
  TenantHealthCheckEnvelope,
  TenantHealthCheckResponse,
} from '../../../Interfaces/api/backoffice/onboarding.interface';
import { OnboardingFunnelEntry } from '../../../Models/backoffice/onboarding-funnel.model';

@Injectable({
  providedIn: 'root',
})
export class OnboardingFunnelService {
  private readonly _apiService = inject(ApiService);

  listRequest(
    status: string,
    page: number,
    pageSize: number,
  ): TypedResourceRequest<LaravelDefaultResponse<OnboardingListResponse>> {
    const params: Record<string, string | number> = { page, pageSize };

    if (status !== '') {
      params['status'] = status;
    }

    return this._apiService.get<LaravelDefaultResponse<OnboardingListResponse>>(
      endpoints.backoffice.onboardings,
      { params, skipLoading: true, skipError: true },
    );
  }

  checkTenantHealth(organizationId: string): Observable<TenantHealthCheckResponse> {
    const request = this._apiService.post<LaravelDefaultResponse<TenantHealthCheckEnvelope>>(
      endpoints.backoffice.organizationTenantHealthCheck(organizationId),
      { skipError: true },
    );

    return this._apiService
      .run<LaravelDefaultResponse<TenantHealthCheckEnvelope>>(request)
      .pipe(map((response) => response.data.check));
  }

  toEntries(
    response: LaravelDefaultResponse<OnboardingListResponse> | undefined,
  ): OnboardingFunnelEntry[] {
    return (response?.data?.onboardings ?? []).map((row) => new OnboardingFunnelEntry(row));
  }

  toSummary(
    response: LaravelDefaultResponse<OnboardingListResponse> | undefined,
  ): Record<string, number> {
    return response?.data?.summary ?? {};
  }

  toTotal(response: LaravelDefaultResponse<OnboardingListResponse> | undefined): number {
    return response?.data?.total ?? 0;
  }
}
